import { useAppStore } from "@/stores";

const PIAPIVersion = "6";

/**
 * Get the base route string for the current company
 * @returns {string} Base route in format: ch.rentouch.piplanning.{version}.room.{company}
 */
export function getBase() {
  const appStore = useAppStore();
  return `ch.rentouch.piplanning.${PIAPIVersion}.room.${appStore.company}`;
}

/**
 * Get the ALM-specific base route
 * @returns {string} ALM base route
 */
export function getALMBase() {
  return getBase() + ".alm";
}
